module.exports = __webpack_public_path__ + "static/media/full-logo.a76fc48d.png";